import { render, staticRenderFns } from "./GroupAddForm.vue?vue&type=template&id=3e13f916&scoped=true&"
import script from "./GroupAddForm.vue?vue&type=script&lang=ts&"
export * from "./GroupAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./GroupAddForm.vue?vue&type=style&index=0&id=3e13f916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e13f916",
  null
  
)

export default component.exports